import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import { useHomeContext } from "../../../context/Home_context";
import { renderTitleWithGradient } from "../../../utils/helper";
import "./HomeBrands.css";

const HomeBrands = () => {
  const { current_expo_data } = useHomeContext();

  const brands = current_expo_data?.brandimage || [];

  if (brands.length === 0) return null;

  let displayBrands = [...brands];
  while (displayBrands.length < 15) {
    displayBrands = [...displayBrands, ...brands];
  }

  return (
    <section className="hb-section" id="bharat-buildcon-brands">
      <div className="hb-container">
        {/* Section Header */}
        <div className="hb-header">
          {current_expo_data?.brand_image_heading && (
            <h2 className="hb-main-title">
              {renderTitleWithGradient(
                current_expo_data.brand_image_heading,
                "hb-title-highlight",
              )}
            </h2>
          )}
          {current_expo_data?.brand_image_sub_heading && (
            <p className="hb-sub-title">
              {current_expo_data.brand_image_sub_heading}
            </p>
          )}
        </div>

        {/* Continuous Marquee Slider */}
        <div className="hb-outer-swiper-wrapper">
          <Swiper
            modules={[Autoplay, FreeMode]}
            loop={true}
            speed={6000}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            freeMode={{
              enabled: true,
              momentum: false,
            }}
            slidesPerView="auto"
            spaceBetween={20}
            allowTouchMove={true}
            className="hb-swiper"
          >
            {displayBrands.map((brand, index) => {
              const imageSrc = brand.image_full_path || brand.image;
              const link = brand.website
                ? brand.website.startsWith("http://") ||
                  brand.website.startsWith("https://")
                  ? brand.website
                  : `https://${brand.website}`
                : null;

              if (!imageSrc) return null;

              return (
                <SwiperSlide
                  key={`${brand.id || "brand"}-${index}`}
                  className="hb-slide"
                >
                  {link ? (
                    <a
                      href={link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hb-brand-card"
                    >
                      <img
                        src={imageSrc}
                        alt={brand.name || "Brand Logo"}
                        className="hb-brand-img"
                        loading="lazy"
                      />
                    </a>
                  ) : (
                    <div className="hb-brand-card">
                      <img
                        src={imageSrc}
                        alt={brand.name || "Brand Logo"}
                        className="hb-brand-img"
                        loading="lazy"
                      />
                    </div>
                  )}
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default HomeBrands;
